export default "__VITE_ASSET__BZQyR7QO__"